import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import UserTable from '../components/users/UserTable';

const UserManagement: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
        Gestión de Usuarios
      </Typography>
      <Paper sx={{ p: 3 }}>
        <UserTable />
      </Paper>
    </Box>
  );
};

export default UserManagement;
